<section class="drf-vault-network-switch-dialog">
  <h2 class="drf-vault-network-switch-dialog__title">
    {{ data.title }}
  </h2>

  <p class="drf-vault-network-switch-dialog__message">
    {{ data.message }}
  </p>

  <div class="drf-vault-network-switch-dialog__actions drf-actions">
    <button
      type="button"
      fuButton
      uiType="secondary"
      size="m"
      data-testid="vault-network-switch-dialog-cancel"
      (click)="cancel()">
      {{ data.cancelLabel }}
    </button>

    <button
      type="button"
      fuButton
      uiType="primary"
      size="m"
      data-testid="vault-network-switch-dialog-confirm"
      (click)="confirm()">
      {{ data.confirmLabel }}
    </button>
  </div>
</section>
